import { defineComponent as _defineComponent } from 'vue'
import HistoryItem from '@/components/formats/RirekishoParts/HistoryItem.vue'
import AutoJobHistories from '@/components/formats/RirekishoParts/AutoJobHistories.vue'
import CareerYagiofferResetDialog from './CareerYagiofferResetDialog.vue'
import hopeIndustryOptions from '@/utils/format-edit/hopeIndustryOptions.json'
import hopeJobcategoryOptions from '@/utils/format-edit/hopeJobcategoryOptions.json'
import { useCareerYagiofferFormatData } from '@/composables/format-edit/useCareerYagiofferHistories'


export default /*#__PURE__*/_defineComponent({
  __name: 'CareerYagiofferJobHistoryCard',
  props: {
    basicData: null,
    currentCardId: null,
    previewErrors: null,
    activeHistoryItem: null,
    jobResetVisible: { type: Boolean },
    descriptionMaxLength: null
  },
  emits: [
  'set-job-histories',
  'update:job-reset-visible',
  'reset-job-histories',
  'add-job-history',
  'delete-job-history',
  'move-job-history',
  'activate-history-item'
],
  setup(__props: any, { emit }) {





const formatData = useCareerYagiofferFormatData()

function onAddJobHistory(
  index?: number,
  columns?: { year?: number; month?: number; description?: string }
) {
  emit('add-job-history', index, columns)
}

return { __sfc: true,emit, formatData, onAddJobHistory, HistoryItem, AutoJobHistories, CareerYagiofferResetDialog, hopeIndustryOptions, hopeJobcategoryOptions }
}

})